import style from "./TableRow.module.scss";
import { Chip } from "@ui";
import { ICost } from "@interfaces/admin/сost";

export function TableRow({
    data
}: {
    data: ICost
}) {
    return (
        <div className={style.row}>
            <div className={style.cell}>
                {dateFormat(data.created_at)}
            </div>
            <div className={style.cell}>
                <Chip
                    text={"#" + data.cost_tag.name}
                    color="blue"
                    size="small"
                />
            </div>
            <div className={style.cell}>
                $ {data.suma} / {(data.suma * data.exchange_rate).toFixed(0)} ₴
            </div>
            <div className={style.cell}>
                $ 1 = {data.exchange_rate} ₴
            </div>
        </div>
    )
}

function dateFormat(date: string) {
    const [year, month, day] = date.split("T")[0].split("-")

    return day + "." + month + "." + year;
}